<template>
    <header class="header-component">
        <dx-toolbar class="header-toolbar">
            <dx-item :visible="menuToggleEnabled && menuVisible"
                     location="before"
                     css-class="menu-button">
                <template #default>
                    <dx-button icon="menu"
                               styling-mode="text"
                               @click="toggleMenuFunc" />
                </template>
            </dx-item>
            <dx-item :visible="!menuVisible"
                     location="before">
                <div style="margin-left:15px"/>
            </dx-item>

            <dx-item v-if="title"
                     location="before"
                     css-class="header-title">
                <div>{{ capitalizeFirstLetter(title) }}</div>
            </dx-item>

            <dx-item location="after">
                <div class="gop-logo">
                    <i class="dx-icon dx-icon-globe"></i>
                    <span>TL</span>
                </div>
            </dx-item>

            <dx-item location="after"
                     locate-in-menu="auto"
                     menu-item-template="menuUserItem">
                <template #default>
                    <div>
                        <dx-button class="user-button authorization"
                                   :width="210"
                                   height="100%"
                                   styling-mode="text">
                            <user-panel :user-name="userName" :menu-items="userMenuItems" menu-mode="context" />
                        </dx-button>
                    </div>
                </template>
            </dx-item>

            <dx-item location="after">
                <div>
                    <dx-button icon="help"
                               styling-mode="text"
                               @click="onHelpClick($event)"
                               :type="helpButtonType">
                    </dx-button>
                </div>
            </dx-item>

            <template #menuUserItem>
                <user-panel :user-name="userName"
                            :menu-items="userMenuItems"
                            menu-mode="list" />
            </template>
        </dx-toolbar>
    </header>
</template>

<script>
    import DxButton from "devextreme-vue/button";
    import DxToolbar, { DxItem } from "devextreme-vue/toolbar";
    import { mapState, mapActions, mapGetters } from "vuex";
    import { store } from "../scripts/store";
    import UserPanel from "./user-panel";
    import { capitalizeFirstLetter, parseQueryString } from "../scripts/helpers";
    import { UITR } from "../scripts/translation";

    export default {
        props: {
            menuToggleEnabled: Boolean,
            title: String,
            toggleMenuFunc: Function,
            logOutFunc: Function
        },
        data() {
            return {
                menuVisible: true,
                translations: UITR,
                helpButtonType: "normal",
            };
        },
        methods: {
            ...mapActions("account", ["logout", 'toggleHelpButton']),
            onUserClick() {
                this.$router.push({
                    path: "/users/users-detail",
                    query: { id: this.userInfo.UserId, sessionID: store.getters["account/sessionID"] }
                });
            },
            onOptionsClick() {
                this.$router.push({
                    path: "/users/user-options-detail",
                    query: { id: this.userInfo.UserOptions.UsOpID, userId: this.userInfo.UserId, sessionID: store.getters["account/sessionID"] }
                });
            },
            onLogoutClick() {
                var self = this;
                this.logout({ clientOnly: false, sessionID: store.getters["account/sessionID"] }).then(() => {
                    self.$router.push({
                        path: "/login-form",
                        query: {
                            useWindowsAuthentication: 0
                        }
                    });
                });
            },
            capitalizeFirstLetter(str) {
                return capitalizeFirstLetter(str);
            },
            onHelpClick(e) {
                this.toggleHelpButton();
                if (this.helpButtonType == "normal") {
                    this.helpButtonType = "default";
                }
                else {
                    this.helpButtonType = "normal";
                }

            },
            setBackgroundColor() {
                //document.getElementsByClassName("header-toolbar")[0].style.backgroundColor = this.backgroundColor
            }
        },
        computed: {
            ...mapState("account", ["userInfo"]),
            ...mapGetters("account", ["backgroundColor"]),
            userName() { return this.userInfo ? this.userInfo.UserFullName : "" },
            userMenuItems() {
                return [
                    {
                        text: this.translations.UI.UserPanel.Profile.tr,
                        icon: "user",
                        onClick: this.onUserClick
                    },
                    {
                        text: this.translations.UI.UserPanel.Settings.tr,
                        icon: "preferences",
                        onClick: this.onOptionsClick
                    },
                    {
                        text: this.translations.UI.UserPanel.Logout.tr,
                        icon: "runner",
                        onClick: this.onLogoutClick
                    }
                ];
            }
        },
        created() {
            var query = parseQueryString(window.location.href)
            if (query.noMenu)
                this.menuVisible = false
        },
        mounted() {
            this.setBackgroundColor();
        },
        watch: {
            backgroundColor() {
                this.setBackgroundColor();
            }
        },
        components: {
            DxButton,
            DxToolbar,
            DxItem,
            UserPanel
        }
    };
</script>

<style lang="scss">
    @import "../themes/generated/variables.base.scss";
    @import "../dx-styles.scss";

    .header-component {
        flex: 0 0 auto;
        z-index: 1;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);

        .dx-toolbar .dx-toolbar-item.menu-button > .dx-toolbar-item-content .dx-icon {
            color: $base-accent;
        }
    }

    .dx-toolbar.header-toolbar {
        padding-left: 0 !important;
        padding-right: 0 !important;

        .dx-toolbar-items-container .dx-toolbar-after {
            padding: 0 40px;

            .screen-x-small & {
                padding: 0 20px;
            }
        }

        .gop-logo {
            font-size: 20px;

            .dx-icon {
                font-size: 18px;
            }

            span {
                margin-left: 5px;
            }
        }
    }

    .dx-toolbar .dx-toolbar-item.dx-toolbar-button.menu-button {
        width: $side-panel-min-width;
        text-align: center;
        padding: 0;
    }

    .header-title {
        font-size: 20px;

        .dx-item-content {
            padding: 0;
            margin: 0;
            padding-bottom: 2px;
        }
    }

    .dx-theme-generic {
        .dx-toolbar {
            padding: 10px 0;
        }

        .user-button > .dx-button-content {
            padding: 3px;
        }
    }

    .gop-title {
        font-size: 55px;
        color: mediumblue;
        font-family: system-ui;
        font-weight: bold;
        background: lightgray;
        box-shadow: 0px 0px 15px 15px lightgrey;
    }
</style>
